<template>
  <div class="box2-container">
    <div class="box_item">
      <div class="item-one">
        <div class="item-one-con">
          <div class="text">
            <div class="label">{{$t("home.box2.text1")}}</div>
            <div class="value c1">{{ ipData.total }}</div>
          </div>
          <img src="@/assets/home_images/type2-bg1.png" class="bg" />
        </div>
      </div>
      <div class="item-one">
        <div class="item-one-con">
          <div class="text">
            <div class="label">{{$t("home.box2.text2")}}</div>
            <div class="value c2">{{ ipData.online }}</div>
          </div>
          <img src="@/assets/home_images/type2-bg2.png" class="bg" />
        </div>
      </div>
      <div class="item-one">
        <div class="item-one-con">
          <div class="text">
            <div class="label">{{$t("home.box2.text3")}}</div>
            <div class="value c3">{{ ipData.offline||0 }}</div>
          </div>
          <img src="@/assets/home_images/type2-bg3.png" class="bg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Box2',
  props: {
    itemData: {
      type: Object,
      required: true, // 默认值是false
      default: function () {
        return {
          total: 0,
          online: 0,
          Offline: 0
        }
      }
    }
  },
  data() {
    return {
      ipData: {
        total: 0,
        online: 0,
        Offline: 0
      }
    }
  },
  watch: {
    itemData: {
      handler(newVal, oldVal) {
        if(oldVal){
          if(newVal.online!=oldVal.online||newVal.total!=oldVal.total){
            this.ipData.total = newVal.total
            this.ipData.online = newVal.online
            this.ipData.Offline = newVal.Offline
          }
        }
      },
      immediate: true
    }
  },
  methods: {
  },
  mounted () {
    this.ipData.total = this.itemData.total
    this.ipData.online = this.itemData.online
    this.ipData.Offline = this.itemData.Offline
  }
}
</script>
<style lang='less'>
.box2-container {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 10px;
  box-sizing: border-box;
  .box_item{
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    flex-direction: row;
    padding-bottom: 15px;
    box-sizing: border-box;
    margin: 0 -10px;
    .item-one {
      width: 33.33%;
      .item-one-con {
        padding: 0 6px;
        position: relative;
        img.bg {
          width: 100%;
          height: auto;
        }
        .text {
          width: 100%;
          position: absolute;
          bottom: 50%;
          left:0;
          margin-bottom: -15px;
          .label {
            width: 100%;
            color: #f0fbff;
            font-size: 14px;
            text-align: center;
            padding: 0;
            margin-bottom: 15px;
          }
          .value {
            width: 100%;
            text-align: center;
            font-size: 28px;
            font-weight: bold;
            color: #fff;
            font-family: Bahnschrift, Impact, "Arial Narrow Bold", sans-serif;

            &.c1 {
              text-shadow: 0 0 15px rgba(18, 118, 216, 1);
              background: -webkit-linear-gradient(to bottom, #ffffff 0%, #ffffff 30%, #00aeff 100%); /* Chrome, Safari */
              background: linear-gradient(to bottom, #ffffff 0%, #ffffff 30%, #00aeff 100%); /* 标准语法 */
              -webkit-background-clip: text; /* Chrome, Safari */
              background-clip: text;
              -webkit-text-fill-color: transparent; /* Chrome, Safari */
              color: transparent; /* 兼容不支持background-clip的浏览器 */
            }

            &.c2 {
              text-shadow: 0 0 15px rgba(209, 160, 47, 1);
              background: -webkit-linear-gradient(to bottom, #ffffff 0%, #ffffff 30%, #ffca58 100%); /* Chrome, Safari */
              background: linear-gradient(to bottom, #ffffff 0%, #ffffff 30%, #ffca58 100%); /* 标准语法 */
              -webkit-background-clip: text; /* Chrome, Safari */
              background-clip: text;
              -webkit-text-fill-color: transparent; /* Chrome, Safari */
              color: transparent; /* 兼容不支持background-clip的浏览器 */
            }

            &.c3 {
              text-shadow: 0 0 15px rgba(149, 149, 149, 1);
              background: -webkit-linear-gradient(to bottom, #ffffff 0%, #ffffff 30%, #999999 100%); /* Chrome, Safari */
              background: linear-gradient(to bottom, #ffffff 0%, #ffffff 30%, #999999 100%); /* 标准语法 */
              -webkit-background-clip: text; /* Chrome, Safari */
              background-clip: text;
              -webkit-text-fill-color: transparent; /* Chrome, Safari */
              color: transparent; /* 兼容不支持background-clip的浏览器 */
            }
          }
        }

        
      }
    }
  }
}
</style>
